/* eslint-disable security/detect-object-injection */
import React, { useContext } from 'react';
import AnimatedButton from '.';
import ApplicationContext from '../../context/ApplicationContext';
import { backNextLanguageContent } from './backNextLanguageContent';

function BackButton(props) {
    const { backType, handleClick, disabled } = props;
    const { backLoader, setBackLoader, selectedLanguage } = useContext(ApplicationContext);
    return (
        <AnimatedButton handleClick={() => {setBackLoader(true); handleClick()}} 
            disabled={backLoader || disabled} id="back-btn" className={`font-semibold text-gray  bg-[#F2F2F2] w-[200px] h-[40px] text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] justify-start fold-normal-text`}>
            <img src={`/images/${backType === 'previous' ? 'blue-back.svg' : 'Back.svg'}`} alt="back" className='flex justify-end w-[35%] h-[1.7em] fold-m-10' />
            <p className='text-center'>{backNextLanguageContent['back'][selectedLanguage]}</p>
        </AnimatedButton>
    );
}

export default BackButton;